<template>
  <v-card class="mx-auto">
    <v-card-title><slot name="title"></slot></v-card-title>
    <v-card-subtitle><slot name="subTitle"></slot></v-card-subtitle>
    <v-card-text>
      <v-list rounded>
        <v-list-item-group v-model="model">
          <template v-for="(item, i) in items">
            <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

            <v-list-item
              v-else
              :key="`item-${i}`"
              :value="item"
              active-class="deep-yellow--text text--accent-4"
            >
              <template v-slot:default="{}">
                <v-list-item-content @click="editItem(item)">
                  <v-list-item-title
                    v-if="type == 'Question'"
                    v-text="item.questionText"
                  ></v-list-item-title>
                  <v-list-item-title
                    v-else
                    v-text="item.answerText"
                  ></v-list-item-title>

                  <v-list-item-text></v-list-item-text>
                </v-list-item-content>

                <v-list-item-action>
                  <v-checkbox
                    v-if="checkbox"
                    color="yellow accent-4"
                    v-model="item.isCorrect"
                    disabled
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-action>
                  <v-icon v-if="deletable" small @click="deleteItem(item)"
                    >mdi-delete</v-icon
                  >
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
      <v-list rounded v-if="add">
        <v-list-item @click="addItem">
          <v-icon>mdi-plus</v-icon>
          Add {{ type }}
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-dialog v-model="dialog" overlay-opacity="0.4" max-width="500px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <slot name="dialog"></slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn text @click="saveItem">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    type: String,
    checkbox: Boolean,
    add: Boolean,
    items: Array,
    valid: Boolean,
    deletable: Boolean,
    editable: Boolean
  },
  data() {
    return {
      dialog: false,
      editedIndex: -1
    };
  },
  created() {
    this.getItems();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New " + this.type : "Edit " + this.type;
    }
  },
  methods: {
    addItem() {
      this.editedIndex = -1;
      this.dialog = true;
    },
    getItems() {
      this.$emit("get-items");
    },
    saveItem() {
      if (this.editedIndex > -1) {
        this.$emit("put-item");
      } else {
        this.$emit("post-item");
      }

      if (this.valid) this.dialog = false;
    },
    editItem(item) {
      if (this.editable) {
        this.editedIndex = this.items.indexOf(item);
        this.$emit("edit-item", item);
        this.dialog = true;
      }
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$emit("delete-item", item);
      }
    }
  },
  watch: {
    dialog: function() {
      if (this.dialog) {
        this.$emit("modal-open");
      } else {
        setTimeout(() => {
          this.$emit("modal-close");
          this.editedIndex = -1;
        }, 300);
      }
    }
  }
};
</script>

<style scoped></style>
